import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "size-4"
}
const _hoisted_2 = {
  key: 0,
  class: "bg-primary absolute top-2 right-[calc(-50%+8px)] left-[calc(50%+18px)] block h-0.5 shrink-0 rounded-full transition-all duration-100 sm:top-4 sm:right-[calc(-50%+16px)] sm:left-[calc(50%+24px)]"
}

import { Check, X } from 'lucide-vue-next';
    import type { OnboardingStep } from '@/types';
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { computed } from 'vue';

    type FormState = OnboardingStep & {
        status: 'completed' | 'rejected' | 'pending';
        selectedAcceptIndex?: string;
    };

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingStep',
  props: {
    step: {},
    formState: {},
    class: {},
    separator: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

    // Use form state status if available, otherwise fall back to step status
    const status = computed(() => props.formState?.status ?? props.step.status);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(
            _unref(cn)(
                'relative flex w-full justify-center gap-2 px-2 transition-opacity duration-100 sm:px-4',
                props.class,
                {
                    'opacity-40': _ctx.step.is_completed,
                },
            )
        )
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["border-primary flex size-4 items-center justify-center rounded-full border-2 text-white transition-all duration-100 sm:size-8", {
                'bg-primary': status.value === 'completed',
                'bg-destructive !border-destructive': _ctx.formState?.status === 'rejected',
            }])
    }, [
      _createVNode(_Transition, {
        name: "icon",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (status.value === 'completed')
            ? (_openBlock(), _createBlock(_unref(Check), {
                key: 0,
                class: "size-4"
              }))
            : (_ctx.formState?.status === 'rejected')
              ? (_openBlock(), _createBlock(_unref(X), {
                  key: 1,
                  class: "size-4"
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_1))
        ]),
        _: 1
      })
    ], 2),
    (_ctx.separator)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass(["text-primary absolute top-full left-0 mt-2 w-full text-center text-[10px] font-medium whitespace-nowrap transition-all duration-100 sm:text-sm", {
                '!text-destructive': _ctx.formState?.status === 'rejected',
            }])
    }, _toDisplayString(_ctx.step.title), 3)
  ], 2))
}
}

})